export enum ReviewerTabListTypes {
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
  REPORTER = "REPORTER",
}
